import Feed100SangjoContainer from "@/containers/Content/Feed100SangjoContainer";

import React from "react";

export default function Sangjo100Toss() {
  return <Feed100SangjoContainer />;
}
